import React from 'react'
import { motion } from 'framer-motion'

const Switch = ({ checked, onChange, disabled = false, size = 'md', className = '' }) => {
  const sizes = {
    sm: {
      container: 'w-8 h-4',
      toggle: 'w-3 h-3',
      translateDistance: 16 // 4 * 4 (translate-x-4 = 16px)
    },
    md: {
      container: 'w-11 h-6',
      toggle: 'w-5 h-5',
      translateDistance: 20 // 5 * 4 (translate-x-5 = 20px)
    },
    lg: {
      container: 'w-14 h-7',
      toggle: 'w-6 h-6',
      translateDistance: 28 // 7 * 4 (translate-x-7 = 28px)
    }
  }

  const sizeConfig = sizes[size]

  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={`
        relative inline-flex items-center ${sizeConfig.container} rounded-full 
        transition-colors duration-200 ease-in-out focus:outline-none 
        focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        ${checked 
          ? 'bg-primary-500 dark:bg-primary-400' 
          : 'bg-gray-200 dark:bg-gray-600'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
    >
      <motion.span
        className={`
          ${sizeConfig.toggle} bg-white rounded-full shadow-lg
          transform transition-transform duration-200 ease-in-out
        `}
        animate={{
          x: checked ? sizeConfig.translateDistance : 0
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30
        }}
      />
    </button>
  )
}

export default Switch